<template>
  <div class="container">
    <el-tabs
      value="tree"
      type="border-card"
      style="flex: 1"
      class="tree-container"
      @tab-click="handleClick()"
      v-if="treeShowed"
    >
      <el-tab-pane name="tree">
        <span slot="label"
          ><em class="el-icon-d-arrow-left"></em> {{ $t("home.tree") }}</span
        >
        <Tree />
      </el-tab-pane>
    </el-tabs>
    <el-button
      type="primary"
      class="refreshButton"
      icon="el-icon-refresh"
      @click="reloadDashboard()"
    ></el-button>
    <el-button
      v-show="!treeShowed"
      @click="treeShowed = !treeShowed"
      icon="el-icon-d-arrow-right"
      id="treeInvisable"
      style="margin-right: 10px; border-radius: 0px"
      plain
    ></el-button>
    <div
      class="tabs"
      v-bind:class="{ treeShowed: treeShowed, treeNotShow: !treeShowed }"
    >
      <el-tabs
        v-model="activeTab"
        type="border-card"
        style="flex: 1; display: flex; flex-direction: column"
        data-v-step="ready"
        @tab-remove="removeHandle"
      >
        <el-tab-pane
          v-if="checkPermission('readDashboard')"
          :label="$t('home.dashboard')"
          name="dashboard"
        >
          <Dashboard :resize="treeShowed" :reload="dashboard_loading" />
        </el-tab-pane>
        <el-tab-pane
          v-for="pointId in pointTabs"
          :key="pointId"
          :label="getPath(pointId)"
          :name="pointId"
          closable
        >
          <PointDetailTab :pointId="pointId" />
        </el-tab-pane>
        <el-tab-pane
          v-if="checkPermission('readMeasurement')"
          :label="$t('home.measurements')"
          name="measurements"
        >
          <MeasurementsTab />
        </el-tab-pane>
        <el-tab-pane
          v-if="checkPermission('readRoute')"
          :label="$t('home.routes')"
          name="routes"
        >
          <TabRouter />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Tree from "./Tree";
import MeasurementsTab from "./Tab_Measurements";
import TabRouter from "./Tab_Route";
import PointDetailTab from "./Tab_Point_Detail";
import Dashboard from "./Tab_Dashboard";
import { mapActions } from "vuex";
import treeHelper from "../util/treeHelper";
export default {
  name: "Home",
  components: {
    Tree,
    PointDetailTab,
    MeasurementsTab,
    TabRouter,
    Dashboard,
  },
  data() {
    return {
      dashboard_loading: false,
      treeShowed: false,
    };
  },
  created() {
    this.$store.dispatch("tree/getTree");
    this.getTelemetry();
    this.getTelemetrySources();
    this.getPoints([]);
    this.getGateways({ macAddress: "", page: "1", pageSize: "" });
    this.getRoutes();
    // this.getUsers();
    this.reloadDashboard();
  },
  methods: {
    ...mapActions("dashboard", ["getAlarmTransactions", "getPointHealthScore"]),
    ...mapActions("point", ["getPoints"]),

    reloadDashboard() {
      this.dashboard_loading = true;
      let x = this.getAlarmTransactions({
        pageSize: 10,
        pageNumber: 1,
        filteredPoints: this.filteredPoints,
      });
      let y = this.getPointHealthScore();
      Promise.all([x, y]).finally(() => {
        this.dashboard_loading = false;
      });
    },
    getPath(id) {
      return treeHelper.pointIdToPath(this.flatTree,id);
    },
    removeHandle(t) {
      this.removePointTab(t);
    },
    ...mapActions("admin", ["getTelemetry","getTelemetrySources"]),
    ...mapActions("gateway", ["getGateways"]),
    ...mapActions("account", [
      "changeTab",
      "finishUserGuiding",
      "removePointTab",
    ]),
    ...mapActions("point", ["getPoints"]),
    ...mapActions("admin", ["getUsers"]),
    ...mapActions("route", ["getRoutes"]),

    handleClick() {
      this.treeShowed = !this.treeShowed;
    },
  },
  computed: {
    filteredPoints() {
      if (this.activePoints.length) {
        return this.points
          .filter((x) => this.activePoints.includes(x._id))
          .map((x) => x._id);
      } else {
        return this.points.map((x) => x._id);
      }
    },
    treeEmpty() {
      return !this.$store.state.tree.tree.length;
    },
    treeLoading() {
      return this.$store.state.tree.status.loading;
    },
    ...mapState("point", ["points", "status"]),
    ...mapState("tree", ["activeTags", "activePoints","flatTree"]),
    ...mapState("account", ["user", "customer", "pointTabs"]),
    activeTab: {
      get() {
        return this.$store.state.account.activeTab;
      },
      set(newValue) {
        return this.$store.dispatch("account/changeTab", newValue);
      },
    },
  },
  watch: {},
};
</script>
<style>

table.el-table__header {
  width: auto !important;
}
table.el-table__body {
  width: auto !important;
}
button.v-step__button.v-step__button-skip {
  float: right !important;
  font-size: 9px !important;
  opacity: 0.3 !important;
}

button.v-step__button.v-step_button-skip:hover {
  opacity: 1 !important;
}
.custom-tree-node {
  min-height: 19px;
  width: 100%;
  padding-right: 15px;
}
.tree-point-options {
  position: absolute;
  right: 5px;
}
.tree-node-title {
  padding-right: 13px;
}
.custom-tree-node:hover .control-group.el-dropdown {
  opacity: 1;
}
.custom-tree-node .control-group.el-dropdown {
  float: right;
  opacity: 0;
}
.el-tree-node > .el-tree-node__children {
  overflow: visible;
}
</style>
<style scoped>
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}

.tree-container {
  display: flex;
  flex-direction: column;
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  display: flex;
}
.treeShowed {
  flex-basis: 80% !important;
}
.treeNotShow {
  flex-basis: 100% !important;
}
#treeInvisable {
  background-color: #f4f4f5;
  align-items: center;
  max-width: 60px;
  flex-basis: 0;
  padding: 5px;
}
.refreshButton {
  position: absolute;
  right: 30px;
  top: 70px;
  padding: 3px;
  z-index: 1900;
}
</style>